var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandIconDvf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1992 14L10.1992 10M14.1992 14V10.8M14.1992 14H10.9992M2.19922 10.8V14M2.19922 14H5.39922M2.19922 14L6.19922 10M14.1992 5.2V2M14.1992 2H10.9992M14.1992 2L10.1992 6M2.19922 5.2V2M2.19922 2H5.39922M2.19922 2L6.19922 6",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIconDvf);
export default __webpack_public_path__ + "static/media/expandIconDVF.1bf316816e680987f1596e4f24bf2c07.svg";
export { ForwardRef as ReactComponent };